import React from "react";
import { Modal } from "react-bootstrap";

export default function RefundCancellationPolicy(props) {
  const { open, closeModal } = props;
  return (
    <Modal show={open} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>Refund & Cancellation Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Our focus is complete customer satisfaction. In the event, if you are
        displeased with the services provided, we will refund back the money,
        provided the reasons are genuine and proved after investigation. Please
        read the fine prints of each deal before buying it, it provides all the
        details about the services or the product you purchase. In case of
        dissatisfaction from our services, clients have the liberty to cancel
        their projects and request a refund from us. Our Policy for the
        cancellation and refund will be as follows:
        <br />
        <br /> <strong className="mt-3">Cancellation Policy</strong>
        <br />
        For Cancellations please use the link mentioned on the website. Requests
        received later than 1 business hour after payment is made online, will
        not be eligible for cancellation.
        <br />
        <br />
        <strong className="mt-3">Refund Policy</strong>
        <br />
        We will try our best to create a suitable experience for you with our
        products. The products purchased are non-returnable and will not be
        exchanged either. In case any client is not completely satisfied with
        the quality of the product, the client should make necessary
        arrangements to send the product back to us at their own cost. On
        inspection, if claim is found to be genuine, replacement shall be
        issued. If the claimed product is -10 GMS, full quantity replacement
        shall be provided at current selling price. In case of deviation of more
        than 10 GMS, quantity shall be replaced taking into consideration the
        quantity received at current prices. If paid by credit card, refunds
        will be issued to the original credit card provided at the time of
        purchase and in case of payment gateway name payments refund will be
        made to the same account.
      </Modal.Body>
    </Modal>
  );
}
